/* SiliDog PDP v2 — live tag preview engine.
   Initializes every [data-sd-pdp2] independently; config comes from the
   embedded <script type="application/json" data-sd-pdp2-config> element. */
(function () {
  'use strict';

  function initAll() {
    document.querySelectorAll('[data-sd-pdp2]').forEach(function (root) {
      if (!root.__sd2) { root.__sd2 = true; init(root); }
    });
  }

  function init(root) {
    var cfgEl = root.querySelector('[data-sd-pdp2-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var state = {
      color: cfg.currentColor,
      size: cfg.defaultSize || null,
      // Back-only products (47 of 83 tags) must open on the back face.
      side: cfg.defaultFace || 'front',
      qty: 1
    };
    var colors = cfg.colors || {};

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    /* ---------- elements ---------- */
    var flip = $('.sd2-flip');
    var frontImg = $('.sd2-face--front img');
    var backImg = $('.sd2-face--back img');
    var frontFace = $('.sd2-face--front');
    var variantInput = $('input[name="id"]');
    var qtyInput = $('input[name="quantity"]');
    var atcBtn = $('.sd2-atc');
    var form = $('form[action*="/cart/add"]');
    var colorNameEl = $('[data-sd2-color-name]');
    var miniBar = $('.sd2-mini');
    var miniImg = $('.sd2-mini-stage img');
    var stickyBar = $('.sd2-sticky');

    /* ---------- text overlay rendering ---------- */
    // ghost defaults shown until the buyer types (LP pattern)
    var GHOST = { front: cfg.ghostFront, back: cfg.ghostBack };

    function lineValues(side) {
      var names = side === 'front' ? cfg.frontFields : cfg.backFields;
      return names.map(function (n) {
        var inp = root.querySelector('input[name="properties[' + n + ']"]');
        return inp ? inp.value : '';
      });
    }

    function renderSide(side) {
      var vals = lineValues(side);
      var anyTyped = vals.some(function (v) { return v.trim() !== ''; });
      $$('.sd2-face--' + side + ' .sd2-tag-line, .sd2-mini [data-mini-side="' + side + '"] .sd2-tag-line')
        .forEach(function (el) {
          var i = parseInt(el.getAttribute('data-tagline'), 10) - 1;
          var v = vals[i] || '';
          var ghost = (GHOST[side] && GHOST[side][i]) || '';
          el.textContent = v !== '' ? v : (anyTyped ? '' : ghost);
          el.classList.toggle('is-ghost', v === '' && !anyTyped && ghost !== '');
        });
      fitLines(side);
    }

    // fit-to-width: shrink each line's font until it fits its box,
    // mirroring how the printed text is sized down for long names
    function fitLines(side) {
      $$('.sd2-face--' + side + ' .sd2-tag-text, .sd2-mini [data-mini-side="' + side + '"].sd2-tag-text')
        .forEach(function (box) {
          var boxW = box.clientWidth;
          var boxH = box.clientHeight;
          if (!boxW || !boxH) return;
          var lines = Array.prototype.slice.call(box.querySelectorAll('.sd2-tag-line'));
          var visible = lines.filter(function (l) { return l.textContent !== ''; });
          if (!visible.length) return;
          // base sizes: line 1 (name) largest, rest equal — proportional to box height
          var weights = lines.map(function (l) {
            return l.getAttribute('data-tagline') === '1' && side === 'front' ? cfg.nameScale : 1;
          });
          var totalW = 0;
          visible.forEach(function (l) { totalW += weights[lines.indexOf(l)]; });
          var unit = (boxH / Math.max(totalW, 1)) / 1.30; // ≈ line-height + breathing room (calibrated vs product photo)
          lines.forEach(function (l) {
            var base = unit * (l.getAttribute('data-tagline') === '1' && side === 'front' ? cfg.nameScale : 1);
            var size = Math.min(base, boxH * 0.6);
            l.style.fontSize = size + 'px';
            // shrink until the line fits horizontally
            var guard = 24;
            while (l.scrollWidth > boxW && size > 6 && guard--) {
              size -= 1;
              l.style.fontSize = size + 'px';
            }
          });
        });
    }

    /* ---------- side flip ---------- */
    function setSide(side, focusSource) {
      if (state.side === side) return;
      state.side = side;
      if (flip) flip.classList.toggle('is-back', side === 'back');
      $$('.sd2-side-btn').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-side') === side);
      });
      $$('.sd2-mini [data-mini-side]').forEach(function (m) {
        m.style.display = m.getAttribute('data-mini-side') === side ? 'flex' : 'none';
      });
      if (!focusSource) {
        // keep personalization tab in sync when toggled from the preview
        $$('.sd2-pz-tab').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-pz-tab') === side);
        });
        $$('.sd2-pz-panel').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-pz-panel') === side);
        });
      }
      renderSide(side);
    }

    $$('.sd2-side-btn').forEach(function (b) {
      b.addEventListener('click', function () { setSide(b.getAttribute('data-side')); });
    });

    /* ---------- personalization tabs + inputs ---------- */
    $$('.sd2-pz-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        var side = t.getAttribute('data-pz-tab');
        $$('.sd2-pz-tab').forEach(function (x) { x.classList.toggle('is-active', x === t); });
        $$('.sd2-pz-panel').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-pz-panel') === side);
        });
        setSide(side, true);
      });
    });

    $$('.sd2-input').forEach(function (inp) {
      var counter = inp.parentElement.querySelector('.sd2-count');
      var max = parseInt(inp.getAttribute('maxlength'), 10) || 20;
      function refreshCount() { if (counter) counter.textContent = inp.value.length + '/' + max; }
      var sdRafPending = false;
      inp.addEventListener('input', function () {
        refreshCount();
        hideEmptyWarn();
        if (sdRafPending) return;
        sdRafPending = true;
        requestAnimationFrame(function () {
          sdRafPending = false;
          renderSide(inp.getAttribute('data-side'));
        });
      });
      inp.addEventListener('focus', function () {
        setSide(inp.getAttribute('data-side'), true);
        miniMaybeShow();
      });
      inp.addEventListener('blur', function () {
        window.setTimeout(function () {
          var a = document.activeElement;
          if (!a || !a.classList || !a.classList.contains('sd2-input')) miniHide();
        }, 120);
      });
      refreshCount();
    });

    /* ---------- variant resolution ----------
       'siblings' mode (default): one single-variant product per color.
       'variants' mode: one product, Size x Color variants (SiliSlider). */
    function currentVariant() {
      var c = colors[state.color];
      if (!c) return null;
      if (cfg.mode === 'variants') return (c.variants || {})[state.size] || null;
      return { id: c.variantId, available: c.available };
    }

    function refreshVariant() {
      var v = currentVariant();
      var soldOut = !v || !v.available;
      if (variantInput && v) variantInput.value = v.id;
      if (atcBtn) {
        atcBtn.disabled = soldOut || isMissing(); // stays locked until line 1 has text
        var label = atcBtn.querySelector('span');
        if (label) label.textContent = soldOut ? (cfg.soldOutLabel || 'Sold out') : (cfg.atcLabel || 'Add to cart');
      }
      if (cfg.mode === 'variants') {
        $$('.sd2-swatch').forEach(function (s) {
          var cc = colors[s.getAttribute('data-color')];
          var vv = cc && (cc.variants || {})[state.size];
          s.classList.toggle('is-soldout', !vv || !vv.available);
        });
      }
    }

    /* ---------- size switching (variants mode only) ---------- */
    $$('.sd2-size-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        state.size = b.getAttribute('data-size');
        $$('.sd2-size-btn').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        refreshVariant();
      });
    });

    /* ---------- color switching ---------- */
    function setColor(name) {
      var c = colors[name];
      if (!c || !c.available) return;
      state.color = name;
      var designLabel = cfg.design || 'tag';
      if (frontImg) { frontImg.src = c.previewFront; frontImg.alt = name + ' ' + designLabel + ' tag — front'; }
      if (backImg) { backImg.src = c.previewBack; backImg.alt = name + ' ' + designLabel + ' tag — back'; }
      if (miniImg) miniImg.src = state.side === 'back' ? c.previewBack : c.previewFront;
      if (frontFace) frontFace.classList.toggle('sd2-face--white', name.toLowerCase() === 'white');
      refreshVariant();
      if (colorNameEl) colorNameEl.textContent = name;
      // title + prices follow the selected sibling product
      // Prefer the sibling product's real title. product.type is unreliable on
      // this store — 56 of 92 products are typed "Circle" regardless of shape.
      var newTitle = c.title || (cfg.shapeLabel ? name + ' ' + cfg.shapeLabel : null);
      var titleEl = $('.sd2-title');
      if (titleEl && newTitle) {
        titleEl.textContent = newTitle;
        try { document.title = document.title.replace(/^[^—–|-]+/, newTitle + ' '); } catch (e) {}
      }
      if (c.price) {
        var priceEl = $('[data-sd2-price]');
        var atcPrice = $('.sd2-atc-price');
        var stickyPrice = $('.sd2-sticky-price');
        if (priceEl) priceEl.textContent = c.price;
        if (atcPrice) atcPrice.textContent = c.price;
        if (stickyPrice) stickyPrice.textContent = c.price;
      }
      $$('.sd2-swatch').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-color') === name);
        s.setAttribute('aria-pressed', s.getAttribute('data-color') === name ? 'true' : 'false');
      });
      // photo gallery follows the color
      var mainImg = $('.sd2-gallery-main img');
      var thumbs = $$('.sd2-thumb');
      (c.photos || []).forEach(function (src, i) {
        if (thumbs[i]) {
          thumbs[i].querySelector('img').src = src;
          thumbs[i].setAttribute('data-full', src);
        }
        if (i === 0 && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = src; }
      });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === 0); });
      // sticky bar
      var stickyName = $('.sd2-sticky-name');
      var stickyThumb = $('.sd2-sticky-thumb');
      if (stickyName && newTitle) stickyName.textContent = newTitle;
      if (stickyThumb && cfg.hasPreview) {
        stickyThumb.src = state.side === 'back' ? c.previewBack : c.previewFront;
      }
      // keep the URL honest for share/refresh without reloading
      if (c.url && window.history && window.history.replaceState) {
        try { window.history.replaceState(null, '', c.url); } catch (e) {}
      }
      var mini = state.side === 'back' ? c.previewBack : c.previewFront;
      if (miniImg) miniImg.src = mini;
    }

    $$('.sd2-swatch').forEach(function (s) {
      s.addEventListener('click', function () { setColor(s.getAttribute('data-color')); });
    });

    /* ---------- media tabs (Preview | Photos) ---------- */
    $$('.sd2-media-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        var pane = t.getAttribute('data-pane');
        $$('.sd2-media-tab').forEach(function (x) { x.classList.toggle('is-active', x === t); });
        $$('.sd2-pane').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-pane') === pane);
        });
        if (pane === 'preview') { renderSide('front'); renderSide('back'); }
      });
    });

    /* ---------- gallery thumbs ---------- */
    $$('.sd2-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = $('.sd2-gallery-main img');
        if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-full'); }
        $$('.sd2-thumb').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });

    /* ---------- qty ---------- */
    $$('.sd2-qty button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        v += b.getAttribute('data-step') === 'up' ? 1 : -1;
        qtyInput.value = Math.max(1, Math.min(99, v));
      });
    });

    /* ---------- required personalization (2026-09-29) ---------- */
    // Client rule: no tag ships without text. The first FRONT line is required when the tag
    // has front lines; design tags (art on the front) require the first BACK line instead.
    // There is no "add it blank anyway" bypass any more.
    var warn = $('.sd2-empty-warn');
    var bypassEmpty = false; // kept for the existing checks below; never set true now
    function requiredInput() {
      var names = (cfg.frontFields && cfg.frontFields.length) ? cfg.frontFields : cfg.backFields;
      var inp = names && names.length ? root.querySelector('input[name="properties[' + names[0] + ']"]') : null;
      if (inp && !inp.offsetParent && cfg.backFields && cfg.backFields.length) {
        // front inputs hidden on this product → fall back to the back line
        inp = root.querySelector('input[name="properties[' + cfg.backFields[0] + ']"]') || inp;
      }
      return inp;
    }
    var reqInput = requiredInput();
    if (reqInput) { reqInput.required = true; reqInput.setAttribute('aria-required', 'true'); }
    function isMissing() { return !!reqInput && reqInput.value.trim() === ''; }
    function showMissing() {
      if (warn) warn.classList.add('is-visible');
      if (reqInput) {
        reqInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { try { reqInput.focus({ preventScroll: true }); } catch (e) {} }, 350);
      }
    }
    function hideEmptyWarn() { if (warn) warn.classList.remove('is-visible'); }
    // Cart apps (Monster Upsells / Upcart) grab the Add-to-cart tap at document level before any
    // theme listener runs, so a click guard alone can't stop them. While line 1 is empty the button
    // is disabled with pointer-events off: no app ever receives a tap on it, and Enter can't submit.
    // Taps on its area land on the parent and show the message instead.
    function syncGate() {
      var m = isMissing();
      if (atcBtn) { atcBtn.disabled = m; atcBtn.style.pointerEvents = m ? 'none' : ''; atcBtn.classList.toggle('is-locked', m); }
    }
    syncGate();
    if (reqInput) reqInput.addEventListener('input', function () { syncGate(); if (!isMissing()) hideEmptyWarn(); });
    if (atcBtn && atcBtn.parentElement) {
      atcBtn.parentElement.addEventListener('click', function (e) {
        if (!isMissing()) return;
        var r = atcBtn.getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) { e.preventDefault(); showMissing(); }
      }, true);
    }
    // The cart app (Upcart) adds on the button CLICK, before any form submit fires, so the
    // guard has to run on the click itself (capture phase) as well as on submit.
    [atcBtn, $('.sd2-sticky-btn')].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        if (isMissing()) { e.preventDefault(); e.stopImmediatePropagation(); showMissing(); }
      }, true);
    });

    if (form) {
      // Capture phase (3rd arg true): run BEFORE the cart app's (Upcart) own submit
      // listener, so blank property inputs are disabled before it serializes the form —
      // otherwise empty line3/line4/backline props leak into the cart drawer + packing slip.
      form.addEventListener('submit', function (e) {
        if (isMissing()) {
          e.preventDefault();
          e.stopImmediatePropagation(); // also stop Upcart from adding an un-personalized tag
          showMissing();
          return;
        }
        // don't post blank properties — keeps the cart + packing slip clean
        $$('.sd2-input').forEach(function (inp) {
          if (inp.value.trim() === '') inp.disabled = true;
        });
        if (atcBtn) { atcBtn.disabled = true; atcBtn.querySelector('span').textContent = cfg.addingLabel || 'Adding…'; }
      }, true);
    }

    /* ---------- dynamic checkout gate ---------- */
    // Shop Pay / PayPal buttons bypass theme JS entirely, so mirror the
    // empty-personalization guard: block them until a line has text, and strip
    // blank inputs right before they serialize the form.
    var dynpay = $('[data-dynpay]');
    function dynEmpty() { return isMissing(); }
    function updateDynGate() {
      if (!dynpay) return;
      dynpay.classList.toggle('is-gated', dynEmpty() && !bypassEmpty);
    }
    if (dynpay) {
      updateDynGate();
      if (form) form.addEventListener('input', updateDynGate);
      dynpay.addEventListener('click', function (e) {
        if (dynpay.classList.contains('is-gated')) {
          e.preventDefault(); e.stopPropagation();
          showMissing();
          return;
        }
        // let it through, but don't ship blank properties to checkout
        $$('.sd2-input').forEach(function (inp) { if (inp.value.trim() === '') inp.disabled = true; });
        setTimeout(function () { $$('.sd2-input').forEach(function (inp) { inp.disabled = false; }); }, 2000);
      }, true);
    }

    /* ---------- sticky mobile ATC ---------- */
    if (stickyBar && 'IntersectionObserver' in window && atcBtn) {
      new IntersectionObserver(function (entries) {
        // show when the CTA has scrolled out of view in either direction
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(atcBtn);
      var stickyBtn = $('.sd2-sticky-btn');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        atcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* ---------- mobile mini preview while typing ---------- */
    var previewStage = $('.sd2-flip-scene');
    var previewVisible = true;
    if (previewStage && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        previewVisible = entries[0].isIntersecting;
        miniMaybeShow();
      }, { threshold: 0.2 }).observe(previewStage);
    }
    function miniMaybeShow() {
      if (!miniBar) return;
      var a = document.activeElement;
      var typing = a && a.classList && a.classList.contains('sd2-input');
      if (typing && !previewVisible && window.innerWidth < 990) {
        miniBar.classList.add('is-visible');
        var c = colors[state.color] || {};
        if (miniImg) miniImg.src = state.side === 'back' ? c.previewBack : c.previewFront;
        renderSide(state.side);
      } else {
        miniBar.classList.remove('is-visible');
      }
    }
    function miniHide() { if (miniBar) miniBar.classList.remove('is-visible'); }

    /* ---------- scroll reveal ---------- */
    if ('IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); }
        });
      }, { threshold: 0.1 });
      $$('.sd2-reveal').forEach(function (el) { ro.observe(el); });
    }

    /* ---------- boot ---------- */
    setColor(state.color);
    if (cfg.hasPreview) {
      // Tier 1 only. Tier 2 pages have no blank-tag preview to render, so the
      // whole overlay engine stays idle rather than measuring absent nodes.
      renderSide('front');
      renderSide('back');
      var sdRzPending = false;
      window.addEventListener('resize', function () {
        if (sdRzPending) return;
        sdRzPending = true;
        requestAnimationFrame(function () { sdRzPending = false; fitLines('front'); fitLines('back'); });
      });
      // fonts/images settling can change measurements
      window.setTimeout(function () { fitLines('front'); fitLines('back'); }, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
